// src/FeedbackManager.js
import { formatLabel } from "./Utils.js";


export const FeedbackManager = {
  notify(text, optionsOrType = 'success') {
    const container = document.getElementById('toast-container') || document.body;
    const toast = document.createElement('div');
    
    let type = 'success';
    let icon = '';
    let speaker = '';
    let duration = 4000;
    
    if (typeof optionsOrType === 'string') {
        type = optionsOrType;
    } else if (typeof optionsOrType === 'object') {
        type = optionsOrType.type || 'info';
        icon = optionsOrType.icon || '';
        speaker = optionsOrType.speaker || '';
        duration = optionsOrType.duration || 4000;
    }

    toast.className = `toast ${type} show`;
    
    // Si es un personaje hablando, cambiar el estilo
    if (speaker === 'Dra. V') {
        toast.style.borderLeft = '4px solid var(--accent)';
        toast.style.boxShadow = '0 0 15px rgba(225, 29, 72, 0.3)';
    } else if (speaker) {
        toast.style.borderLeft = '4px solid var(--primary)';
        toast.style.boxShadow = '0 0 15px rgba(0, 243, 255, 0.3)';
    }

    let innerHTML = '';
    if (speaker) {
        innerHTML += `<div style="font-size: 0.7rem; opacity: 0.8; font-weight: bold; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">`;
        if (icon) {
             innerHTML += `<i data-lucide="${icon}" style="width: 12px; height: 12px;"></i>`;
             setTimeout(() => { if (window.lucide) lucide.createIcons({root: toast}); }, 0);
        }
        innerHTML += `${speaker}</div>`;
    }
    innerHTML += `<div style="font-size: 0.9rem;">${text}</div>`;
    
    toast.innerHTML = innerHTML;
    container.appendChild(toast);
    setTimeout(() => toast.remove(), duration);
  },


  buildHint(node) {
    const tags = node.tags || [];
    const hintPool = [];
    if (node.letal_si_falla) hintPool.push("Un error aquí puede ser letal: confirma el paso más crítico.");
    if (tags.includes("tiempo_dependiente")) hintPool.push("El tiempo cambia el pronóstico: prioriza la intervención inmediata.");
    if (tags.includes("contraindicacion")) hintPool.push("Busca contraindicaciones antes de elegir el tratamiento.");
    if (tags.includes("urgencias")) hintPool.push("Piensa en ABC y seguridad primero.");
    if (tags.includes("diagnostico")) hintPool.push("Identifica el dato que confirma el diagnóstico clave.");
    if (tags.includes("farmaco")) hintPool.push("Recuerda dosis/elección de fármaco de primera línea.");
    if (tags.includes("algoritmo")) hintPool.push("Sigue el algoritmo paso a paso, sin saltarte el orden.");
    
    if (hintPool.length === 0) {
      hintPool.push("Analiza la prioridad clínica y el objetivo inmediato del manejo.");
    }
    return hintPool[Math.floor(Math.random() * hintPool.length)];
  },

  buildLearningFlashcard(node, result, isCorrect, isSlow) {
    const urgency = node?.letal_si_falla
      ? `<div style="background: rgba(225, 29, 72, 0.1); color: var(--accent); padding: 8px; border-radius: var(--radius); border-left: 3px solid var(--accent); margin-bottom: 12px; font-weight: bold; font-size: 0.8em;">⚠️ PUNTO DE SEGURIDAD: Caso potencialmente letal.</div>`
      : "";
    
    const speedNote = isSlow
      ? "⏱️ Foco de mejora: la decisión correcta llegó tarde."
      : "";
    
    const trap = (node?.error_tipico && typeof node.error_tipico === 'string')
      ? `<div style="font-size: 0.85em; opacity: 0.8; margin-top: 10px; border-top: 1px dashed rgba(0,0,0,0.1); padding-top: 8px;"><strong>Trampa:</strong> ${node.error_tipico}</div>`
      : "";


    const perla = node?.perla 
      ? `<div style="background: var(--primary); color: #fff; padding: 12px; border-radius: var(--radius); margin: 12px 0; font-size: 0.95em; box-shadow: var(--shadow-sm);">
           <strong>💡 Perla:</strong> ${node.perla}
         </div>`
      : "";

    const fallbackJustificacion = node?.justificacion || result?.retro || '';
    const justificacion = fallbackJustificacion
      ? `<div style="font-size: 0.9em; line-height: 1.5; margin-bottom: 12px; padding: 0 4px;">
           <strong>Justificación:</strong> ${fallbackJustificacion}
         </div>`
      : "";

    const fuentes = (node?.fuentes && node.fuentes.length > 0)
      ? `<div style="font-size: 0.75rem; opacity: 0.6; margin-top: 10px; font-style: italic;">📚 Referencia: ${node.fuentes.join(', ')}</div>`
      : "";

    return `
      <div class="card feedback-flashcard" style="border-top: 6px solid ${isCorrect ? 'var(--primary)' : 'var(--accent)'}; padding: 20px; animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);">
        <h4 style="color: ${isCorrect ? 'var(--primary)' : 'var(--accent)'}; margin-top: 0; display:flex; justify-content:space-between; align-items:center;">
          ${isCorrect ? '✨ DECISIÓN CORRECTA' : '⚠️ AJUSTE REQUERIDO'}
          <span style="font-size: 0.6em; opacity: 0.5; letter-spacing: 0.1em;">${formatLabel(node.id) || ''}</span>
        </h4>

        
        ${urgency}

        <div style="margin: 10px 0; font-size: 0.9em;">
          <small style="opacity:0.6; text-transform:uppercase; font-weight:900;">Acción Correcta:</small><br>
          <strong style="color: var(--primary);">${result.correct_option_text}</strong>
        </div>

        ${perla}
        ${justificacion}
        ${trap}
        ${fuentes}
        
        <div style="margin-top:20px; display:flex; justify-content:space-between; align-items:center; border-top: 2px solid #eee; padding-top:15px;">
           <div style="font-size:0.75rem; opacity:0.5;">Pulsa <strong>Enter</strong> o haz <strong>clic</strong> para continuar</div>
           <div style="color: var(--primary); font-weight:bold; font-size:0.8rem;">${speedNote}</div>
        </div>
      </div>
    `;
  }
};
